/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Claim } from './Claim';
import {
    ClaimFromJSON,
    ClaimFromJSONTyped,
    ClaimToJSON,
    ClaimToJSONTyped,
} from './Claim';

/**
 * Paged list of claims.
 * @export
 * @interface ClaimListResponse
 */
export interface ClaimListResponse {
    /**
     * 
     * @type {Array<Claim>}
     * @memberof ClaimListResponse
     */
    claims: Array<Claim>;
    /**
     * 
     * @type {number}
     * @memberof ClaimListResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimListResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimListResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the ClaimListResponse interface.
 */
export function instanceOfClaimListResponse(value: object): value is ClaimListResponse {
    if (!('claims' in value) || value['claims'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function ClaimListResponseFromJSON(json: any): ClaimListResponse {
    return ClaimListResponseFromJSONTyped(json, false);
}

export function ClaimListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claims': ((json['claims'] as Array<any>).map(ClaimFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function ClaimListResponseToJSON(json: any): ClaimListResponse {
    return ClaimListResponseToJSONTyped(json, false);
}

export function ClaimListResponseToJSONTyped(value?: ClaimListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claims': ((value['claims'] as Array<any>).map(ClaimToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

